<template>
  <div :class="$attrs.class">
    <component :is="form.Field" :name="name">
      <template #default="formProps">
        <FormCheckbox
          :id="id"
          :model-value="formProps.field.state.value"
          :label="!$slots.default ? label : undefined"
          :disabled="disabled"
          :description="description"
          @update:model-value="formProps.field.handleChange"
          @change="
            (event) => formProps.field.handleChange(event.target.checked)
          "
        >
          <slot />
        </FormCheckbox>
      </template>
    </component>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  form: any // The form instance from @tanstack/vue-form
  name: string
  label?: string
  disabled?: boolean
  id?: string
  description?: string
}>()
</script>
